<template>
  <div class="wrapper">
    <Menu />
    <Header title="Şifre Yenileme" hideMore />
    <div
      class="body-area pt70"
      style="    height: -webkit-fill-available; display: flex; flex: 1; align-items: center; justify-content: center; flex-direction: column; padding: 0px 25px"
    >
      <h2
        class="text-center fc-1"
        :class="status == false ? 'fc-1' : 'fc-2'"
        style="margin-bottom: 20px"
      >{{message}}</h2>

      <input
        v-if="status != true"
        type="text"
        v-model="email"
        class="form-input"
        placeholder="E-Posta"
      />

      <input v-if="status != true" type="text" v-model="token" class="form-input" placeholder="Kod" />

      <input
        v-if="status != true"
        type="password"
        v-model="password"
        class="form-input"
        placeholder="Yeni Şifreniz"
      />

      <button
        v-if="status == true"
        class="confirm-button"
        @click="$router.push({name: 'Login'})"
      >Giriş Yap</button>
      <button class="confirm-button" @click="activate" v-if="status != 200">Şifre Güncelle</button>
    </div>
    <Footer />
  </div>
</template>


<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import axios from "axios";
export default {
  name: "Activate",
  components: {
    Footer,
    Menu,
    Header
  },
  data() {
    return {
      message: null,
      status: 0,
      email: this.$route.query.email,
      token: this.$route.query.code,
      password: null
    };
  },
  methods: {
    activate() {
      this.message = "Şifreniz Yenileniyor...";
      var data = new FormData();
      data.append("email", this.email);
      data.append("code", this.token);
      data.append("password", this.password);
      axios
        .post("uyelik/parola-guncelle", data)
        .then(res => {
          this.message = res.data.error || res.data.message;
          this.status = res.data.status;
        })
        .catch(err => {
          this.message = "Şifre yenileme kodunuz hatalı veya süresi dolmuş.";
          this.status = false;
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/ChangePassword.vue